import { GetCustomerRewardsOrderDocument } from '../../../graphql/camel'
import useCamelQuery, { UseCamelQuery } from '../../../hooks/useCamelQuery'

export type UseGetCustomerRewardsOrder = UseCamelQuery<typeof GetCustomerRewardsOrderDocument>

export const useGetCustomerRewardsOrder = ({
  orderId,
}: {
  orderId: string
}): UseGetCustomerRewardsOrder =>
  useCamelQuery(GetCustomerRewardsOrderDocument, {
    variables: {
      orderId,
    },
  })
